import { PathBase } from "@constellation-academy/epic-ui";

export class ProductEditPath extends PathBase {
	static readonly pathKey = "edit";
}
